import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatCheckboxModule, MatIconModule, MatMenuModule } from '@angular/material';
import { DirectivesModule } from '../../directives/directives.module';
import { TreeViewComponent } from './fc-tree-view.component';
import { TreeViewService } from './fc-tree-view.service';

@NgModule({
  entryComponents: [
    TreeViewComponent
  ],
  declarations: [
    TreeViewComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatCheckboxModule,
    MatMenuModule,
    DirectivesModule
  ],
  providers: [
    TreeViewService
  ],
  exports: [
    TreeViewComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class TreeViewModule {}
